<template>
    <div class="header"> 
        <div class="fast-menu">
            <ul>
                <li> <b-icon-list :title= "$t('menus.menu')" @click="changeCollapse"></b-icon-list> </li>
                <li> <b-icon-tv :title= "$t('menus.trafficList')"></b-icon-tv> </li>
                <li> <b-icon-card-list :title= "$t('menus.accounts')"></b-icon-card-list> </li>
                <li> <b-icon-people-fill :title= "$t('menus.users')"></b-icon-people-fill> </li>
                <li> <b-icon-pencil-square :title= "$t('menus.defination')"></b-icon-pencil-square> </li>
                <li> <b-icon-clipboard-data :title= "$t('menus.reports')"></b-icon-clipboard-data> </li>
                <li> <b-icon-plus-circle :title= "$t('menus.addShortcut')"></b-icon-plus-circle> </li>
            </ul>  
        </div>
        <div class="settings">
           <ul>
                <li>
                    <b-nav>  
                        <b-nav-item-dropdown id="my-nav-dropdown" right>
                            <template slot="button-content"> <country-flag :country="activeLang.detail.flagCode" size="normal" /> {{activeLang.detail.name}} </template>
                            <b-dropdown-item v-for="lang in languages" :key="lang.detail.code" @click="changeLang(lang.detail.code)"> 
                                <country-flag :country="lang.detail.flagCode" size="normal" /> {{lang.detail.name}}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-nav>    
                </li>
                <!-- 
                    Bildirim aktif edilince kullanılacka
                    <li> <b-icon-bell-fill title="Abone Listesi"> </b-icon-bell-fill> <b-badge variant="primary" pill>9</b-badge>  </li>
                -->
                <li> 
                    <b-nav>  
                        <b-nav-item-dropdown text="Osman Yavuz Demir" id="my-nav-dropdown" right>
                            <template slot="button-content"> <b-avatar :size="28"></b-avatar> {{getName()}}</template>
                            <b-dropdown-item @click=" goSettings"> {{$t('menus.settings')}} </b-dropdown-item>
                            <b-dropdown-item @click="logout"> {{$t('menus.signOut')}} </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-nav>  
                </li>
            </ul>  
        </div>
    </div>
</template>

<script>
    import CountryFlag from 'vue-country-flag'
    import i18n from '@/plugins/i18n'
    import {eventBus} from '../main'
    import jwt_decode from "jwt-decode";

    export default {
        name: 'Header',
        data: () =>{
            return {
                languages: Object.values(i18n.messages),
                activeLang: Object.values(i18n.messages).find( (language) => { return language.detail.code == localStorage.getItem("lang") })
            }
        },
        methods:{
            getName: function(){
                return jwt_decode(localStorage.getItem('access_token')).username
            },
            goSettings: function(){
                let user_id = jwt_decode(localStorage.getItem('access_token')).user_id;
                this.$router.push( { path: '/User/'+user_id+'/Edit' })
            },
            changeLang: (lang) =>{
                localStorage.setItem("lang", lang)
                location.reload();
            },
            changeCollapse: () => {
                eventBus.$emit("collapse")
            },
            logout: function(){
                localStorage.removeItem('access_token')
                localStorage.removeItem('refresh_token')
                location.reload();
            }
        },
        components:{
            CountryFlag
        }
    }
</script>

<style lang="css" scoped>
    @import "./styles/header.min.css";
</style>


// WEBPACK FOOTER //
// src/components/Header.vue